import update from 'immutability-helper';

import { identifySelectableSeats } from './selectableSeatsReducer';

// ------------------------------------
// Constants
// ------------------------------------
export const SELECT_SEAT = 'SELECTED_SEATS/SELECT_SEAT';
export const DESELECT_SEAT = 'SELECTED_SEATS/DESELECT_SEAT';
export const SET_SELECTED_SEATS = 'SELECTED_SEATS/SET_SELECTED_SEATS';
export const SELECT_FREESEATING = 'SELECTED_SEATS/SELECT_FREESEATING';
export const DESELECT_FREESEATING = 'SELECTED_SEATS/DESELECT_FREESEATING';
export const SET_SELECTED_FREESEATINGS = 'SELECTED_SEATS/SET_SELECTED_FREESEATINGS';

// ------------------------------------
// Actions
// ------------------------------------

export function selectSeat(seat) {
	return {
		type: SELECT_SEAT,
		seat,
	};
}

export function deselectSeat(seat) {
	return {
		type: DESELECT_SEAT,
		seat,
	};
}

export function setSelectedSeats(seats) {
	return {
		type: SET_SELECTED_SEATS,
		seats,
	};
}

export function selectFreeSeating(freeSeatingIdentifier) {
	return {
		type: SELECT_FREESEATING,
		freeSeatingIdentifier,
	};
}

export function deselectFreeSeating(freeSeatingIdentifier) {
	return {
		type: DESELECT_FREESEATING,
		freeSeatingIdentifier,
	};
}

export function setSelectedFreeSeatings(freeSeatingIdentifiers) {
	return {
		type: SET_SELECTED_FREESEATINGS,
		freeSeatingIdentifiers,
	};
}

// ------------------------------------
// Action Creators
// ------------------------------------

export function setSelectedSeatsAndUpdateSelectable(seats) {
	return (dispatch) => {
		dispatch(setSelectedSeats(seats));
		return dispatch(identifySelectableSeats(seats));
	};
}

export function deselectSeatAndUpdateSelectable(seat) {
	console.info('REMOVE_RESERVED_SEAT');
	return (dispatch, getState) => {
		dispatch(deselectSeat(seat));
		return dispatch(identifySelectableSeats(
			getState().selectedSeats.selectedSeats
		));
	};
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
	[SELECT_SEAT]: (state, action) => update(state,
		{
			selectedSeats: { $push: [action.seat] },
		}
	),
	[SET_SELECTED_SEATS]: (state, action) => update(state,
		{
			selectedSeats: { $set: action.seats },
		}
	),
	[DESELECT_SEAT]: (state, action) => update(state,
		{
			selectedSeats: { $splice: [[state.selectedSeats.indexOf(action.seat), 1]] },
		}
	),
	[SELECT_FREESEATING]: (state, action) => update(state,
		{
			selectedFreeSeatings: ((state.selectedFreeSeatings.indexOf(action.freeSeatingIdentifier) === -1) ?
			{ $push: [action.freeSeatingIdentifier] }
			: { $set: state.selectedFreeSeatings }),
		}
	),
	[DESELECT_FREESEATING]: (state, action) => update(state,
		{
			selectedFreeSeatings: { $splice: [[state.selectedFreeSeatings.indexOf(action.freeSeatingIdentifier), 1]] },
		}
	),
	[SET_SELECTED_FREESEATINGS]: (state, action) => update(state,
		{
			selectedFreeSeatings: { $set: action.freeSeatingIdentifiers },
		}
	),
};

// ------------------------------------
// Reducer
// ------------------------------------
export const initialState = {
	selectedSeats: [],
	selectedFreeSeatings: [],
};

export default function reducerFunction(state = initialState, action) {
	const handler = ACTION_HANDLERS[action.type];
	return handler ? handler(state, action) : state;
}
